<div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 result-values">
  <po-widget>
    <div class="po-row">
      <div class="po-xl-7 po-lg-7 po-md-7 po-sm-7 po-pl-0">
        <span class="po-font-text-bold">Demonstrativo de Resultado Financeiro - DRF</span>
      </div>
      <div class="po-xl-5 po-lg-5 po-md-5 po-sm-5">
        <po-select name="select" [ngModel]="itemSelected" [p-options]="selectItem"
          (p-change)="changeEventSelect($event)">
        </po-select>
      </div>
    </div>
    <div class="icon-loading" *ngIf="loading && !errorApi">
      <app-loading-icon></app-loading-icon>
    </div>
    <div class="icon-loading" *ngIf="!loading && errorApi">
      <span class="po-icon po-icon-exclamation"></span>
    </div>
    <div class="po-md-12 po-text-center" *ngIf="!loading && errorApi">
      <div *ngIf="!loading && errorApi">
        <app-error [message]="message"></app-error>
      </div>
    </div>
    <div class="po-table-main-container" *ngIf="!loading && !errorApi">
      <div class="po-table-wrapper" style="opacity: 1">
        <div class="p-infinite-scroll">
          <table class="po-table">
            <thead>
              <tr class="po-table-header">
                <th class="po-table-header-ellipsis">
                  <div class="po-table-header-flex">
                    <span class="po-table-header-ellipsis"> Receita total com venda </span>
                  </div>
                </th>
                <th class="po-table-header-ellipsis">
                  <div class="value-column">
                    <span class="po-table-header-ellipsis">R$ {{itemListResult.value}} </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="po-table-group-row" *ngFor="let item of itemList">
              <tr class="po-table-row">
                <td class="po-table-column" ng-reflect-ng-class="">
                  <div class="po-table-column-cell notranslate">
                    <!-- campo signal type
                      1 (+)
                      2 (-)
                      3 (=) positivo
                      4 o (-) com recuo 
                      5 (=) negativo
                    -->
                    <span class="po-icon po-icon-plus-circle po-mr-1 value-green" *ngIf="item.signal_type == 1"></span>
                    <span class="po-icon po-icon-minus-circle po-mr-1 value-red" *ngIf="item.signal_type == 2"></span>
                    <span class="po-icon po-mr-1 btn-equals" *ngIf="item.signal_type == 3 || item.signal_type == 5"> =
                    </span>
                    <span *ngIf="item.signal_type != 4">{{item.type_field}}</span>
                    <span *ngIf="item.signal_type == 4">................. {{item.type_field}}</span>
                  </div>
                </td>
                <td class="po-table-column value-column" ng-reflect-ng-class="">
                  <div class="po-table-column-cell notranslate">
                    <span *ngIf="item.signal_type == 1 || item.signal_type == 3" class="value-green"><b>R$ {{item.value}}</b></span>
                    <span *ngIf="item.signal_type == 2 || item.signal_type == 4 || item.signal_type == 5"
                      class="value-red"><b>R$ {{item.value}}</b></span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </po-widget>
</div>